import React from 'react';

import RealtimeUpdateSubscriptionWrapper, {
  RealtimeUpdateSubscriptionWrapperProps,
} from 'realtime/RealtimeUpdateSubscriptionWrapper';

export default function ProcessRealtimeUpdateSubscriptionWrapper(
  props: RealtimeUpdateSubscriptionWrapperProps
): JSX.Element | null {
  return (
    <RealtimeUpdateSubscriptionWrapper
      {...props}
      messageFilter="no_filter"
      hasIncompleteDataShouldRefetch={props.hasIncompleteDataShouldRefetch}
    />
  );
}
